export default __webpack_public_path__ + "static/media/under-construction.75db905e.jpg";